import { createFileRoute } from '@tanstack/react-router';
import { PendingDocumentsScreen } from '../../../features/inbox/pending-documents-screen';

/**
 * „Documente → Documente în așteptare", anunțat în meniu de la #110, construit la #109.
 *
 * Adresa e cea pe care o știa meniul de atunci: ecranul a înlocuit pagina „în lucru", ruta
 * a rămas.
 */
export const Route = createFileRoute('/_authenticated/documente/in-asteptare')({
  component: PendingDocumentsScreen,
});
